import React from 'react';
import { clsx } from 'clsx';
import { PipelineNodeRelation } from '../pipeline-node-relation/PipelineNodeRelation';
import { getSyncFrequencyDisplayText } from '../../utils/utils';
import styles from './SyncFrequencyReviewStep.module.scss';
import { HdIcon } from '../../../../../components';

export function ReviewListItem({ pipeline }) {
  return (
    <div className={styles.listItem}>
      <div className={styles.pipelineDetailsCell}>
        <PipelineNodeRelation pipeline={pipeline} textClassName={styles.nodeLogoText} />
      </div>

      <div className={clsx(styles.syncFrequencyCell, 'ml-5')}>
        <div className='text-body-2'>
          {getSyncFrequencyDisplayText(pipeline.sync_execution_policy)}
        </div>
      </div>

      <div className=''>
        {pipeline?.updated_manually ? (
          <div className='text-success text-body-2 d-flex'>
            <HdIcon name='checked-tick' />
            Manually Updated
          </div>
        ) : (
          <div className='text-info-secondary text-body-2 d-flex'>
            <HdIcon name='run-now' />
            Auto Suggested
          </div>
        )}
      </div>
    </div>
  );
}
